module.exports = __webpack_public_path__ + "static/feature-2-d72dc97ff55df1683a0d274e05529bef.jpg";